/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import '../../styles/Header.css';
import { useNavigate } from 'react-router-dom';
import { useProduct } from '../../context/ProductContext';


type HeaderProps = {
  title: string;
  rightElement?: React.ReactNode;
};

const Header: React.FC<HeaderProps> = ({ title, rightElement }) => {
  const { isProduct, setProduct } = useProduct();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const btnRef = useRef<HTMLButtonElement | null>(null);
  const menuRef = useRef<HTMLUListElement | null>(null);

  useEffect(() => {
    function onDocClick(e: MouseEvent) {
      if (!open) return;
      const t = e.target as Node;
      if (btnRef.current?.contains(t)) return;
      if (menuRef.current?.contains(t)) return;
      setOpen(false);
    }
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') setOpen(false);
    }
    document.addEventListener('mousedown', onDocClick);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDocClick);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  return (
    <header className="header">
      <h1 onClick={() => navigate('/')} className="header-title">{title}</h1>

      <div className="header-right">
        {rightElement && <div className="header-slot">{rightElement}</div>}

        <div className="product-switcher">
          <button
            ref={btnRef}
            className="product-switcher-btn"
            onClick={() => setOpen(!open)}
            aria-haspopup="menu"
            aria-expanded={open}
            aria-controls="product-switcher-menu"
          >
            Products
            <svg
              aria-hidden="true"
              width="16"
              height="16"
              viewBox="0 0 20 20"
              className={`chev ${open ? 'rot' : ''}`}
            >
              <path
                d="M5.5 7.5l4.5 4.5 4.5-4.5"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </button>

          {open && (
            <ul
              id="product-switcher-menu"
              ref={menuRef}
              role="menu"
              className="product-switcher-menu"
            >
              <li role="none">
                <button
                  role="menuitem"
                  className="menu-item"
                  onClick={() => { setOpen(false); setProduct('resume'); }}
                >
                  Resume
                </button>
              </li>
              <li role="none">
                <button
                  role="menuitem"
                  className="menu-item"
                  onClick={() => { setOpen(false); setProduct('site-assistant'); }}
                >
                  Site Assistant
                </button>
              </li>
              <li role="none">
                <button
                  role="menuitem"
                  className="menu-item"
                  onClick={() => { setOpen(false); setProduct('bot-canvas'); }}
                >
                  Bot Canvas
                </button>
              </li>
            </ul>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
